import {applicationContext} from '@@/package/application/applicationContext';
import {type PublicRuntimeConfig} from '@nuxt/schema';
import {type CookieSerializeOptions} from 'cookie';
import { CookieKeyType } from "~~/package/mapper/common/model/CookieKeyType";

export interface PolicyCookies {
    necessary: boolean;
    performance: boolean;
    // 2026-07 쿠키 정책 v1.1에서 신설. 개정 전에 저장된 쿠키에는 이 필드가 없으며,
    // undefined는 "재동의 필요" 신호로 사용된다 (application/utils/cookieConsent.ts 참고).
    functional?: boolean;
}
export const getCookie = <T>(key: CookieKeyType): T | null => {
    const cookieValue = applicationContext.getCookies().get(key, {
        parseJSON: true
    });
    return cookieValue as T;
};

export const setPolicyCookies = (agreements: PolicyCookies): void => {
    setCookie(CookieKeyType.POLICY, agreements, defaultOptions(365));
};

export const getPolicyCookies = (): PolicyCookies => {
    return getCookie(CookieKeyType.POLICY) || {necessary: false, performance: false};
};

export const setCookie = (key: CookieKeyType, value: any, options?: CookieSerializeOptions): void => {
    const configure: PublicRuntimeConfig = applicationContext.getConfig();
    const domain = configure.COOKIE_DOMAIN;

    if(!options || !options.expires) {
        options = defaultOptions();
    }

    applicationContext.getCookies().set(key, value, {path: '/', domain, ...options});
};

export const removeCookie = (key: CookieKeyType, options?: CookieSerializeOptions): void => {
    const configure: PublicRuntimeConfig = applicationContext.getConfig();
    const domain = configure.COOKIE_DOMAIN;
    applicationContext.getCookies().remove(key, {path: '/', domain, ...options});
};


// SEC-1 (TSK-10568): JS-readable cookies set via this util are reserved for
// non-sensitive flags (POLICY, OPEN_CREDIT_BANNER, REDIRECT_URL, LANG, etc.).
// The AccessToken JWT is now an HttpOnly cookie issued by the backend on
// /user/signIn, /user/auth/email, and OAuth success — never set it via
// setCookie() here.
const defaultOptions = (expiresDate = 30, httpOnly = false): CookieSerializeOptions => {
    const date = new Date();
    return {
        expires: new Date(date.setDate(date.getDate() + expiresDate)),
        httpOnly,
        secure: true
    }
}
